console.log('Footer script loaded!');

//import './from_parent_scripts_v105'

import $ from 'jquery';

$(function () {
    console.log('jQuery is working 02!');
});


// block01 Begin
// global disable focus on page
$(document).ready(function ($) {
    $(function () {
        // Hack fix by focus
        $(window).on('scroll', function (event) {
            let currentOffset = $(window).scrollTop();

            $('.ginput_container_checkbox input[type="checkbox"]').on('click', function (event) {
                $(window).scrollTop(currentOffset);
            });
        });

        console.log('#debug01::JS in the footer works.');
        console.log("#debug01::Cookie data: ", document.cookie);
        // Cookies by tutors buttons
        // buttons in header

        $('#chooseTutorButton').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set: ", document.cookie);
        });

        $('#phoneOfMathemaInHeader').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('.menu-item-16691 a').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('.menu-item-20939 a').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // buttons on main page
        $('#main-button1').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // classes of ua school
        // 1
        $('#choice_79_1_0').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 2
        $('#label_79_1_1').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 3
        $('#label_79_1_2').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 4
        $('#label_79_1_3').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 5
        $('#label_79_1_4').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 6
        $('#label_79_1_5').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 7
        $('#label_79_1_6').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 8
        $('#label_79_1_7').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 9
        $('#label_79_1_8').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 10
        $('#label_79_1_9').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 11
        $('#label_79_1_10').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // classes of pl school
        // Zerowka
        $('#label_94_1_0').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 1
        $('#label_94_1_1').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 2
        $('#label_94_1_2').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 3
        $('#label_94_1_3').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 4
        $('#label_94_1_4').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 5
        $('#label_94_1_5').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 6
        $('#label_94_1_6').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 7
        $('#label_94_1_7').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 8
        $('#label_94_1_8').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 9
        $('#label_94_1_9').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 10
        $('#label_94_1_10').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // 11
        $('#label_94_1_11').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('.set-click_event_tutor_true-cookie').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('#callMeButton').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('#chooseTutor30sec').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        $('#floatingPhoneButton').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=true; path=/; expires=" + expiryDate.toUTCString();

            // debug val of cookie
            console.log("DEBUG::Cookie is set:", document.cookie);
        });

        // FAQ click
        $(".item.faq-item").click(function () {  //use a class, since your ID gets mangled
            $(this).toggleClass("active");      //add the class to the clicked element
        });


        // Move js, by fix bug with send cookies data ( eventID, etc) to form {


        $('.gfield_label:contains("eventID")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("eventID"));
        });

        $('.gfield_label:contains("utm_medium")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_medium"));
        });

        $('.gfield_label:contains("utm_source")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_source"));
        });

        $('.gfield_label:contains("utm_partner")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_partner"));
        });

        $('.gfield_label:contains("utm_content")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_content"));
        });

        $('.gfield_label:contains("utm_campaign")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_campaign"));
        });

        $('.gfield_label:contains("utm_term")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("utm_term"));
        });

        $('.gfield_label:contains("aff_sub")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("aff_sub"));
        });

        $('.gfield_label:contains("aff_id")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("aff_id"));
        });
		
		$('.gfield_label:contains("UsrGoogleGlid")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("gclid"));
        });

        $('.gfield_label:contains("placement")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("placement"));
        });

        $('.gfield_label:contains("site_source_name")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("site_source_name"));
        });

        $('.gfield_label:contains("UsrFacebookFbc")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("_fbc"));
        });

        $('.gfield_label:contains("UsrFacebookFbp")').each(function () {
            var tutname = $(this).closest('.gfield').find('input');
            $(tutname).val(getCookie("_fbp"));
        });

        // By tutors
        $('#chooseTutorButton').on('click', function () {
            // lifetime
            let expiryDate = new Date();
            expiryDate.setTime(expiryDate.getTime() + (24 * 60 * 60 * 1000));

            // set cookie click_event_tutor to click_choose-tutor_upper event
            document.cookie = "click_event_tutor=click_choose-tutor_upper; path=/; expires=" + expiryDate.toUTCString();
        });

        // } Move js, by fix bug with send cookies data ( eventID, etc) to form

        // insert block03 from footer.php Begin
        // whenever we hover over a menu item that has a submenu
        $('.wpml-ls-legacy-list-horizontal .wpml-ls-current-language a').on('click', function (event) {
            event.preventDefault();
            $('header .language-switcher').toggleClass("hovered");
        });
        console.log("#debug::block03 is work");
        // insert block03 from footer.php End
        // insert block04 from footer.php Begin
        $('.blocktrigger > a').on('click', function (event) {
            event.stopPropagation();
            event.stopImmediatePropagation();
            var parent = $(this).parent();
            if (parent.hasClass('ihavechildren')) {
                $(this).toggleClass('opnd');
                $(this).parent().find('.menu-item').toggleClass('parentopn');
            }
        });
        console.log("#debug::block04 is work");
        // insert block04 from footer.php End
        // insert block05 from footer.php Begin
        function getURLWithoutDomainForUTM() {
            const currentUrl = new URL(window.location.href);
            let pathname = currentUrl.pathname; // Отримуємо шлях після домену
            let newString = pathname.replace(/\//g, '-');
            newString = newString.replace(/\//g, '-');
            console.log("#debug::function01 is work");
            return newString;
        }

        function addTagToLinks(className) {
            // Знаходимо всі елементи 'a' з заданим класом
            const links = $('.' + className + " a");
            let urlForUTM = getURLWithoutDomainForUTM();
            urlForUTM = urlForUTM.split('?')[0];
            // Перебираємо кожне посилання
            links.each(function () {
                const currentHref = $(this).attr('href');
                const newHref = currentHref + urlForUTM;
                $(this).removeAttr('href');
                $(this).attr('onclick', `location.href='${newHref}'`);
            });
            console.log("#debug::function02 is work");
        }

        addTagToLinks('addutmterm');
        console.log("#debug::block05 is work");
        // insert block05 from footer.php End

        // DISABLE: insert block0001 from scripts_v105.js Begin, TO DO: Fix bug and disable scripts_v105.js in footer.php. This code not work in /pl/kartowka-new/
        // Sticky Header
        /*
        var lastScrollTop = 0;
        $(window).scroll(function () {
            var stickyNavTop = 10;
            var stickyNav = function () {
                var scrollTop = $(window).scrollTop();
                if (scrollTop > stickyNavTop) {
                    $("header").addClass("sticky").addClass("scrolled");
                } else {
                    $("header").removeClass("sticky").removeClass("scrolled");
                }
                if (scrollTop < lastScrollTop) {
                    $("header").removeClass("sticky");
                }
                lastScrollTop = scrollTop;
            };
            stickyNav();
        });

        // Galleries
        var swiper = new Swiper(".mySwiper", {
            loop: true,
            lazy: true,
            slidesPerView: 2,
            spaceBetween: 20,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                },
            },
        });

        // Media About Us
        var swiper = new Swiper(".mediaAboutUs", {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 2,
            slidesPerGroupSkip: 1,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 6,
                    spaceBetween: 20,
                },
            },
        });

        // Trustpilot Slider
        var trustSwiper = new Swiper(".trustpilotSwiper", {
            loop: true,
            slideToClickedSlide: true,
            centeredSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                768: {
                    direction: "horizontal",
                    spaceBetween: 6,
                    slidesPerView: 1,
                },
                1024: {
                    direction: "vertical",
                    spaceBetween: 24,
                    slidesPerView: 2,
                },
            },
        });

        // Blog Galleries
        var swiper = new Swiper(".wp-block-gallery", {
            loop: true,
            lazy: true,
            slidesPerView: 1,
            spaceBetween: 10,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
        });

        // Faq
        $(".faq-list .faq-item").on("click", function () {
            $(this).toggleClass("active");
            $(this).siblings(".faq-answer").toggleClass("visible");
        });

        // Mobile menu
        $(".menu-trigger").on("click", function () {
            $(".mobile-menu").toggleClass("visible");
            console.log(`#debug::on click event to .menu-trigger is work`);
        });

        // Bitrix Modals
        $(".modal-trigger").on("click", function () {
            $(".request-modal").addClass("visible");
        });

        $(".two-modal").on("click", function () {
            $(".two-plus-two-modal").addClass("visible");
        });

        $(".button-blog-form-cta").on("click", function () {
            console.log('button_form_cta');
            $(".blog-Ñta-modal").addClass("visible");
        });


        $(".close-modal").on("click", function () {
            $(".two-plus-two-modal").removeClass("visible");
            $(".request-modal").removeClass("visible");
            $(".blog-Ñta-modal").removeClass("visible");
        });

        // Phone masks
        //$('#personphone').mask('38 (999) 999 99 99');
        //$('#promophone').mask('38 (999) 999 99 99');
        //$('#referralphone').mask('38 (999) 999 99 99');
        // insert block0001 from scripts_v105.js End
         */
    });
});
// block01 End

// block02 Begin
const queryString2 = window.location.search;
const urlParams2 = new URLSearchParams(queryString2);
const setCookie = (cname, cvalue, exdays) => {
    const expires = new Date(Date.now() + exdays * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${cname}=${cvalue}; expires=${expires}; path=/`;
};

if (urlParams2.get("utm_source") != null) {
    setCookie("utm_source", urlParams2.get("utm_source"), 30);
}
if (urlParams2.get("utm_medium") != null) {
    setCookie("utm_medium", urlParams2.get("utm_medium"), 30);
}
if (urlParams2.get("utm_partner") != null) {
    setCookie("utm_partner", urlParams2.get("utm_partner"), 30);
}
if (urlParams2.get("utm_content") != null) {
    setCookie("utm_content", urlParams2.get("utm_content"), 30);
}
if (urlParams2.get("utm_campaign") != null) {
    setCookie("utm_campaign", urlParams2.get("utm_campaign"), 30);
}
if (urlParams2.get("utm_term") != null) {
    setCookie("utm_term", urlParams2.get("utm_term"), 30);
}
if (urlParams2.get("aff_sub") != null) {
    setCookie("aff_sub", urlParams2.get("aff_sub"), 30);
}
if (urlParams2.get("aff_id") != null) {
    setCookie("aff_id", urlParams2.get("aff_id"), 30);
}
if (urlParams2.get("gclid") != null) {
    setCookie("gclid", urlParams2.get("gclid"), 30);
}
if (urlParams2.get("placement") != null) {
    setCookie("placement", urlParams2.get("placement"), 30);
}
if (urlParams2.get("site_source_name") != null) {
    setCookie("site_source_name", urlParams2.get("site_source_name"), 30);
}
//

// Iframe Videos
var videoActive;

function playVideo(element) {
    if (videoActive) {
        stopVideo();
    }
    var videoUrl = element.dataset.videoUrl;
    var vParam = videoUrl.split('v=');
    var videoId = vParam[1].includes('&') ? vParam[1].substring(0, vParam[1].indexOf('&')) : vParam[1];
    var embedUrl =
        'https://www.youtube.com/embed/' +
        videoId +
        '?rel=0&controls=1&showinfo=0&autoplay=1&start=5';
    var figure = element.querySelector('figure');
    var iframe = element.querySelector('iframe');

    element.classList.add('active');
    iframe.src = embedUrl;
    videoActive = element;
}

function stopVideo() {
    var figure = videoActive.querySelector('figure');
    var iframe = videoActive.querySelector('iframe');
    videoActive.classList.remove('active');
    iframe.src = '';
}

console.log('#debug::block02 is work');
// block02 End
